import { Model } from "../alcance/models/model";
import { Usuario } from "../alcance/models/usuario";
import { Andar } from "./andar";
import { Edificacao } from "./edificacao";
import { Funcao } from "./funcao";
import { Turno } from "./turno";

export class Brigadista extends Model{
    private _edificacao?: Edificacao;

    usuario!: Usuario;
    usuario_id!: number;
    andar?: Andar;
    andar_id!: number;
    turno?: Turno;
    turno_id!: number;
    edificacao_id!: number;
    externo_id?: number;
    bombeiro!: boolean;
    ativo!: boolean;
    media!: number;
    pertence_edificacao: string | number | undefined;
    funcao?: Funcao;
    conf?: BrigadistaConf;

    get edificacao(): Edificacao | undefined{
        return this.andar ? this.andar.edificacao : (this.turno ? this.turno.edificacao : this._edificacao);
    }

    set edificacao(e){
        this._edificacao = e;
    }
}

export interface BrigadistaConf{
    responsavel: boolean;
    ignora_responsavel: boolean;
    andares: boolean;
    turnos: boolean;
}
